import { Button, Divider, Empty, Input, Select } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import StepsButtons from "../CommonComponents/StepsButtons";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import FormInput from "../CommonComponents/FormInput";
import FormSelect from "../CommonComponents/FormSelect";
import FormUpload from "../CommonComponents/FormUpload";
import FormDatePicker from "../CommonComponents/FormDatePicker";
import FormAddressSelect from "../CommonComponents/FormAddressSelect";
import { ISignatoryDataProps } from "../IDataCollection";

const SignatoryData = (props: ISignatoryDataProps) => {
  const {
    selectedInvestor,
    advanceStep,
    translations,
    goBackStep,
    onChangeInvestor,
    onAddItem,
    onRemoveItem,
    errors,
    isOcrLoading,
    handleBeforeUpload,
    setSelectedInvestor,
    foundsOrigin,
    language,
	countries
  } = props;

  const hasSelectedTwoPayslips = (selectedInvestor?.foundsOrigin || []).filter(
	(item: any) => item.foundsOriginDocument === "Últimas dos nóminas").length > 0;

  return (
    <div className="investor-step">
      <label className="investor-select">Inversor:</label>
      <Select
        style={{ width: "100%" }}
        placeholder={selectedInvestor?.institutionLong}
        disabled
      />
      <Divider />
      <div className="investor-step-header">
        <QFTitle title={translations?.foundsOrigin} size="extrabig" />
        <Button
          icon={<PlusCircleOutlined />}
          className="add-item-button"
          onClick={() => onAddItem("foundsOrigin")}
        >
          {translations?.add}
        </Button>
      </div>
      <div className="investor-step-form-row">
        {selectedInvestor?.foundsOrigin?.length > 0 &&
          selectedInvestor?.foundsOrigin.map((source: any, index: number) => (
            <>
              <FormSelect
                field="foundsOrigin"
                label={translations?.foundsOrigin}
                key={source?.foundsOrigin}
                index={index}
                mandatory
                arrayField="foundsOrigin"
                value={source?.foundsOrigin}
                options={foundsOrigin}
                optionField="es"
                optionName={language}
                placeholder={translations?.selectAnOption}
                onChangeInvestor={(value: any, field: any) =>
                  onChangeInvestor(value, field, index, "foundsOrigin")
                }
                error={errors?.foundsOrigin?.[index]?.foundsOrigin}
              />
              <FormSelect
                options={
                  foundsOrigin?.find((o: any) => o.es === source?.foundsOrigin)
                    ?.documentOptions || []
                }
                mandatory
                arrayField="foundsOrigin"
                field="foundsOriginDocument"
                placeholder={translations?.selectAnOption}
                optionField="es"
                onChangeInvestor={(value: any, field: any) =>
                  onChangeInvestor(value, field, index, "foundsOrigin")
                }
                value={source?.foundsOriginDocument}
                optionName={language}
                label={translations?.documentToUpload}
                disabled={!source?.foundsOrigin}
                error={errors?.foundsOrigin?.[index]?.foundsOriginDocument}
              />
              <div className="investor-step-form-row two-columns-inline">
                <FormUpload
                  mandatory
                  translations={translations}
                  label={translations?.supportDocument}
                  uploadedFile={source?.foundsOriginFile}
				  disabled={!source?.foundsOriginDocument}
                  error={errors?.foundsOrigin?.[index]?.foundsOriginFile}
                  handleBeforeUpload={(e: any) =>
                    handleBeforeUpload(
                      e,
                      false,
                      "foundsOriginFile",
                      index,
                      "foundsOrigin"
                    )
                  }
                />
                <Button
                  type="text"
                  className="remove-item-button"
                  disabled={selectedInvestor?.foundsOrigin?.length === 1}
                  onClick={() => onRemoveItem("foundsOrigin", index)}
                  icon={<CloseOutlined />}
                />
              </div>
            </>
          ))}
      </div>
		{hasSelectedTwoPayslips && (
		<p className="form-disclaimer">
			{translations?.twoLatestPayslipsRequired}.
		</p>
		)}
      <Divider />
      <div>
        {selectedInvestor?.signatories?.length > 0 &&
          selectedInvestor?.signatories.map((signatory: any, index: number) => {
            return (
              <div key={index}>
                {index !== 0 && <Divider />}
                <QFTitle
                  title={
                    <>
                      {translations?.signatory} {signatory?.name}{" "}
                      {signatory?.firstLastName} {signatory?.secondLastName}
                    </>
                  }
                  size="big"
                />
                <div className="investor-step-form-row">
                  <FormInput
                    mandatory
                    field="name"
                    error={errors?.signatories?.[index]?.name}
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.name || ""}
                    label={translations.names}
                    placeholder={translations?.completeField}
                  />
                  <FormInput
                    mandatory
                    field="firstLastName"
                    error={errors?.signatories?.[index]?.firstLastName}
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.firstLastName || ""}
                    label={translations.firstLastName}
                    placeholder={translations?.completeField}
                  />
                  <FormInput
                    field="secondLastName"
                    error={errors?.signatories?.[index]?.secondLastName}
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.secondLastName || ""}
                    label={translations.secondLastName}
                    placeholder={translations?.completeField}
                  />
                  <FormInput
				  	mandatory
                    field="email"
                    error={errors?.signatories?.[index]?.email}
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.email || ""}
                    label={translations.email}
					disabled={true}
                    placeholder={translations?.completeField}
                  />
                  <FormUpload
                    mandatory
                    translations={translations}
                    label={translations?.identityDocument}
                    uploadedFile={signatory?.documentFile}
                    error={errors?.signatories?.[index]?.documentFile}
                    handleBeforeUpload={(e: any) =>
                      handleBeforeUpload(
                        e,
                        true,
                        "documentFile",
                        index,
                        "signatories"
                      )
                    }
                    isOcrLoading={
                      isOcrLoading?.[`signatories_${index}`] || false
                    }
                  />
                  <FormInput
                    label={translations?.documentNumber}
                    mandatory
                    error={errors?.signatories?.[index]?.documentNumber}
                    field="documentNumber"
                    isOcrLoading={
                      isOcrLoading?.[`signatories_${index}`] || false
                    }
                    index={index}
                    arrayField="signatories"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.documentNumber || ""}
                    placeholder={translations?.completeField}
                    translations={translations}
                  />
                  <FormDatePicker
                    label={translations?.dateOfExpiration}
                    field="dateOfExpiration"
                    mandatory
                    error={errors?.signatories?.[index]?.dateOfExpiration}
                    value={signatory?.dateOfExpiration}
                    index={index}
                    translations={translations}
                    arrayField="signatories"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    placeholder={translations?.selectADate}
                    isOcrLoading={
                      isOcrLoading?.[`signatories_${index}`] || false
                    }
                  />
                  <FormDatePicker
                    label={translations?.dateOfBirth}
                    field="dateOfBirth"
                    value={signatory?.dateOfBirth}
                    index={index}
                    error={errors?.signatories?.[index]?.dateOfBirth}
                    mandatory
                    arrayField="signatories"
                    translations={translations}
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    placeholder={translations?.selectADate}
                    isOcrLoading={
                      isOcrLoading?.[`signatories_${index}`] || false
                    }
                  />
					<FormSelect
                      field="nationality"
                      label={translations?.nationality}
                      error={errors?.signatories?.[index]?.nationality}
                      index={index}
                      mandatory
                      arrayField="signatories"
                      value={signatory?.nationality}
                      options={countries}
                      optionField="name_lang2"
            		  optionName={language === "es" ? "name_lang2" : "name_lang1"}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "signatories"
                        )
                      }
                      placeholder={translations?.selectAnOption}
                    />
                </div>
                <p className="form-disclaimer">
                  {translations?.verifyDocument}
                </p>
                <div className="investor-step-form-row two-columns">
                  <FormAddressSelect
                    error={errors?.signatories?.[index]?.taxAddress}
                    fieldKey={`signatory.${index}.taxAddress`}
                    targetField="taxAddress"
                    mandatory
                    translations={translations}
                    initialValue={signatory?.taxAddress?.taxAddress}
                    updateFn={(updater: any) =>
                      setSelectedInvestor((prev: any) => ({
                        ...prev,
                        signatories: prev.signatories.map(
                          (s: any, idx: number) =>
                            idx === index
                              ? {
                                  ...s,
                                  taxAddress: {
                                    ...s.address,
                                    ...updater(s.address)
                                  },
                                }
                              : s
                        ),
                      }))
                    }
                  />
                  <FormInput
                    field="taxAddress.taxAddressLine2"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.taxAddress?.taxAddressLine2}
                    label={translations.addressSecondLine}
                    placeholder={translations?.completeField}
                    arrayField="signatories"
                    index={index}
                    translations={translations}
                  />
                </div>
                {selectedInvestor?.signatories[index]?.taxAddress && (
                  <div className="investor-step-form-row three-columns">
                    <Input
                      value={`${translations.city}: ${selectedInvestor?.signatories[index]?.taxAddress?.taxAddressCity}`}
                      style={{ width: "100%" }}
                      disabled
                    />
                    <Input
                      value={`${translations.country}: ${selectedInvestor?.signatories[index]?.taxAddress?.taxAddressCountry}`}
                      style={{ width: "100%" }}
                      disabled
                    />
                    <Input
                      value={`${translations.postalCode}: ${selectedInvestor?.signatories[index]?.taxAddress?.taxAddressPostalCode}`}
                      style={{ width: "100%" }}
                      disabled
                    />
                  </div>
                )}
              </div>
            );
          })}
        {selectedInvestor?.signatories?.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={translations?.noBeneficialOwners}
          />
        )}
      </div>
      <Divider />
      <StepsButtons
        disableLast
        advanceStep={advanceStep}
        goBackStep={goBackStep}
        steps={3}
        currentStep={1}
        translations={translations}
        nextText={translations?.next}
      />
    </div>
  );
};

export default SignatoryData;
